import { Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import CustomButton from '../../../../v2-components/Antd/Button';
import CustomCheckbox from '../../../../v2-components/Antd/Checkbox';
import CustomFormItem from '../../../../v2-components/Antd/FormItem';
import CustomInput from '../../../../v2-components/Antd/Input';
import CustomSelect from '../../../../v2-components/Antd/Select/index';
import CustomDatePicker from '../../../../v2-components/Antd/DatePicker';
import GoogleMap from '../GoogleMap';
import { CustomNotification } from '../../../../v2-components/Notification';
import { Notification } from '../../../../v2-components/Notification/constant';
import { GeocodeAddress } from '../GeocodeAddress';
import { FORM } from './constants/form.constant';
import { PHARMACY_LOCAL } from './constants/pharmacy-local.constant';
import { Service } from '../../service';
import { capitalizeWords } from './handle/capitalize-words.handle';
import { titleForm } from './handle/title-form.handle';
import { transformSchedule } from './handle/transform-schedule.handle';
import { temporalClosingTime } from './handle/validate-temporal-closing-time.handle';
import { isTodayOrFuture } from './handle/validate-is-today-or-future.handle';
import { isValidDateRange } from './handle/validate-is-data-range.handle';
import { checkDateOverlap } from './handle/validate-check-date-overlap.handle';
import { useTranslation } from 'react-i18next';
import { CalendarOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';

import './style.scss';
import { getDaysInRange } from './handle/get-days-in-range.handle';

export default function PharmacyLocalForm(props) {
	console.log(props);
	const { t } = useTranslation('global');
	const { data, onFinish, communesOptiones } = props;
	const [form] = useForm();
	const [editable, setEditable] = useState(!data);
	const [latlng, setLatlng] = useState(data?.region + ' ,' + data?.commune + ', ' + data?.direction);
	const [coordinates, setCoordinates] = useState(null);
	const [disableSaveButton, setDisableSaveButton] = useState(false);
	const { id } = useParams();

	const [selectedMotive, setSelectedMotive] = useState(null);
	const [temporalChanges, setTemporalChanges] = useState([]);
	const [original, setOriginal] = useState([]);
	const [lockBeginToday, setLockBeginToday] = useState(false);
	const [isTodaySelected, setIsTodaySelected] = useState(false);
	const [snapshot, setSnapshot] = useState({}); // Foto de los valores del form
	const [snapshotChanges, setSnapshotChanges] = useState([]); // Foto del arreglo temporalChanges

	const disablePastAndToday = (current) =>
		current &&
		(current.isSame(moment(), 'day') || // hoy
			current.isBefore(moment(), 'day')); // fechas anteriores a hoy

	const MOTIVES = {
		CAMBIO_HORARIO: 'Cambio de Horario',
		FARMACIA_TURNO: 'Farmacia de turno',
		CERRADO: PHARMACY_LOCAL.MOTIVE.filter((m) => m.toLowerCase().includes('cerrado')),
	};

	const isNothingSelected = !selectedMotive;
	const isCambioHorario = selectedMotive === MOTIVES.CAMBIO_HORARIO;
	const isFarmaciaTurno = selectedMotive === MOTIVES.FARMACIA_TURNO;
	const isCerrado = MOTIVES.CERRADO.includes(selectedMotive);

	const isCerradoVacaciones = isCerrado && selectedMotive.toLowerCase().includes('vacaciones');

	const disableDesde = isNothingSelected || (!isFarmaciaTurno && !isCerrado && !isCambioHorario);

	const disableHasta = isNothingSelected || isCambioHorario || isFarmaciaTurno || (isCerrado && !isCerradoVacaciones);

	const disableInicioFin = isNothingSelected || isFarmaciaTurno || isCerrado;

	const toUnixUTC = (dateStr, timeStr) => {
		const [dd, mm, yy] = dateStr.split('/').map(Number);
		const [hh, mi, ss] = timeStr.split(':').map(Number);

		const ms = Date.UTC(2000 + yy, mm - 1, dd, hh, mi, ss);
		return Math.floor(ms / 1000);
	};

	const buildOriginalDailySchedules = (appliesToDays, dataSchedule) => {
		const originalDailySchedules = appliesToDays
			.map((day) => {
				const schedule = dataSchedule.find((item) => item.day === day);

				if (schedule) {
					return {
						day: schedule.day,
						open: schedule.open,
						close: schedule.close,
					};
				}

				return null;
			})
			.filter((item) => item !== null);

		return originalDailySchedules;
	};

	const buildPayload = (item, localId, dataSchedule) => {
		const days = [0,1,2,3,4,5,6];
		const appliesToDays = getDaysInRange(item.from, item.to);
		const originalDailySchedules = buildOriginalDailySchedules(appliesToDays, dataSchedule);
		const originalSchedule = buildOriginalDailySchedules(days, dataSchedule);
		let newBegin = item.begin;
		let newEnd = item.end;

		if (item.begin === 'CERRADO' || item.end === 'CERRADO') {
			newBegin = '00:00:00';
			newEnd = '23:59:59';
		}

		return {
			start: toUnixUTC(item.from, newBegin), // ← UTC
			end: toUnixUTC(item.to, newEnd), // ← UTC
			reason: item.motive?.trim(),
			override_open: item.begin,
			override_close: item.end,
			applies_to_days: appliesToDays,
			original_daily_schedules: originalDailySchedules,
			original_schedule: originalSchedule,
			local_id: localId,
		};
	};

	const handleTempSaveChanges = async () => {
		const originalIds = new Set(original.map((o) => o.id).filter(Boolean));
		const draftIds = new Set(temporalChanges.map((d) => d.id).filter(Boolean));

		const toCreate = temporalChanges.filter((item) => !item.id); // nuevos
		const toDelete = [...originalIds].filter((id) => !draftIds.has(id)); // faltantes

		if (!toCreate.length && !toDelete.length) return;

		const service = new Service();

		const createReqs = toCreate.map((item) => service.createSpecialSchedule(buildPayload(item, id, data.schedule)));

		const deleteReqs = toDelete.map((scheduleId) => service.deleteSpecialSchedule(id, scheduleId));

		try {
			await Promise.all([...createReqs, ...deleteReqs]);

			setOriginal(temporalChanges);
			CustomNotification({
				type: Notification.type.success,
				message: Notification.message.success,
				description: `Horarios temporales creados: ${toCreate.length} | Eliminados: ${toDelete.length}`,
			});
		} catch (err) {
			console.error('Error al guardar cambios de horarios especiales', err);
		}
	};

	const handleFromDateChange = (date) => {
		if (!date) return;

		const today = moment();
		const isToday = date.isSame(today, 'day');
		setIsTodaySelected(isToday);

		if (isToday) {
			const jsDay = date.day(); // 0 = domingo, 1 = lunes, ..., 6 = sábado
			const customIndex = jsDay === 0 ? 6 : jsDay - 1;
			const scheduleOpen = form.getFieldValue(['schedule', customIndex, 'open']);
			form.setFieldsValue({ begin: scheduleOpen });
			form.setFieldsValue({ end: undefined });
			setLockBeginToday(true);
		} else {
			form.setFieldsValue({ begin: undefined });
			setLockBeginToday(false);
		}
	};

	const getValidEndOptions = () => {
		const allOptions = PHARMACY_LOCAL.TIME.filter((item) => item.value !== 'CERRADO');

		if (!isTodaySelected) {
			return allOptions;
		}

		const now = moment();
		const currentMinutes = now.minutes();
		const roundedNow = now.clone().startOf('hour');

		if (currentMinutes < 30) {
			roundedNow.add(30, 'minutes');
		} else {
			roundedNow.add(1, 'hour');
		}

		return allOptions.filter((option) => {
			const optionTime = moment(option.value, 'HH:mm:ss');
			return optionTime.isAfter(roundedNow);
		});
	};

	const handleSelect = (index) => {
		const time = {
			value: !form.getFieldValue(['schedule', index, 'status']) ? 'Cerrado' : '00:00',
			onChange: (selectedValue) => handleCheckTime(selectedValue, index),
		};
		return time;
	};

	const handleCheckTime = (selectedValue, index) => {
		console.log('selectedValue: ', selectedValue, index);
		if (selectedValue === PHARMACY_LOCAL.CLOSED) {
			console.log('entro a cerrar ambos horarios');
			form.setFieldValue(['schedule', index, 'close'], PHARMACY_LOCAL.CLOSED);
			form.setFieldValue(['schedule', index, 'open'], PHARMACY_LOCAL.CLOSED);
			return;
		}
	};

	const handleOnFinishFailed = () => {
		CustomNotification({
			type: Notification.type.error,
			message: Notification.message.error,
			description: 'Revise el formulario, hay datos faltantes',
		});
	};

	useEffect(() => {
		GeocodeAddress(data?.region + ' ,' + data?.commune + ', ' + data?.direction)
			.then((response) => {
				console.log('GeocodeAddress [data]: ', response);
				setCoordinates(response);
			})
			.catch((e) => {
				console.log('error:', e);
			});
	}, [data]);

	useEffect(() => {
		GeocodeAddress(latlng)
			.then((response) => {
				setDisableSaveButton(false);
				console.log('GeocodeAddress [latlng]: ', response);
				setCoordinates(response);
			})
			.catch((e) => {
				setDisableSaveButton(true);
				console.log('error:', e);
				CustomNotification({ type: 'error', message: null, description: 'La dirección que estas intentando buscar no existe' });
			});
	}, [latlng, form]);

	useEffect(() => {
		if (!id) return;

		new Service()
			.getSpecialSchedule(id)
			.then((res) => {
				console.log('res', res);
				const list = res ?? [];

				const mapped = list.map((item) => {
					const start = moment.unix(item.start).utc();
					const end = moment.unix(item.end).utc();

					return {
						id: item._id ?? undefined,
						from: start.format('DD/MM/YY'),
						to: end.format('DD/MM/YY'),
						begin: start.format('HH:mm:ss'),
						end: end.format('HH:mm:ss'),
						motive: item.reason,
					};
				});

				setTemporalChanges(mapped);
				setOriginal(mapped);
			})
			.catch((e) => {
				console.error(e);
			});
	}, [id]);

	const handleGetAddress = () => {
		const region = form.getFieldValue('region') || '';
		const commune = form.getFieldValue('commune') || '';
		const direction = form.getFieldValue('direction') || '';
		const googleMaps = region + ', ' + commune + ', ' + direction;
		form.setFieldValue('google_maps', googleMaps);
		setLatlng(googleMaps);
		return googleMaps;
	};

	const handleResetCommune = () => {
		form.setFieldValue('commune');
	};

	const handleOnFinish = async (values) => {
		try {
			const { motive, from, to, begin, end, ...payload } = values;
			setEditable(false);
			const resultTransform = await transformSchedule({ formObject: payload, data: data, coordinates: coordinates });
			const { special_schedule, ...rest } = resultTransform;
			onFinish(rest);
			handleTempSaveChanges();
		} catch (e) {
			setEditable(true);
			console.log(e);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleGetAddress();
		}
	};

	const handleChangeMotive = (value) => {
		setSelectedMotive(value);
		setLockBeginToday(false);

		form.setFieldsValue({
			from: null,
			to: null,
			begin: null,
			end: null,
		});
	};

	const handleCancelMotive = () => {
		setSelectedMotive(null);
		form.setFieldsValue({
			motive: null,
			from: null,
			to: null,
			begin: null,
			end: null,
		});
	};

	const handleSaveTemporalChange = () => {
		const CAMBIO_HORARIO = PHARMACY_LOCAL.MOTIVE[0]; // 'Cambio de Horario'
		const FARMACIA_TURNO = PHARMACY_LOCAL.MOTIVE[1]; // 'Farmacia de turno'

		const values = form.getFieldsValue(['motive', 'from', 'to', 'begin', 'end']);

		let newChange = {
			id: null,
			motive: null,
			from: null,
			to: null,
			begin: null,
			end: null,
		};

		if (!values.motive) {
			CustomNotification({
				type: 'error',
				message: 'Motivo requerido',
				description: 'Debes seleccionar un motivo antes de guardar el cambio temporal.',
			});
			return;
		}

		switch (values.motive) {
			case CAMBIO_HORARIO:
				newChange = {
					id: null,
					motive: values.motive,
					from: values.from ? values.from.format('DD/MM/YY') : null,
					to: values.from ? values.from.format('DD/MM/YY') : null,
					begin: values.begin,
					end: values.end,
				};

				if (!newChange.from || !newChange.begin || !newChange.end) {
					CustomNotification({
						type: 'error',
						message: 'Campos requeridos',
						description: 'Necesitas llenar todos los campos',
					});
					return;
				}
				if (!temporalClosingTime(values)) {
					return;
				}
				if (!isTodayOrFuture(newChange.from)) {
					return;
				}
				break;

			case FARMACIA_TURNO:
				newChange = {
					id: null,
					motive: values.motive,
					from: values.from ? values.from.format('DD/MM/YY') : null,
					to: values.from ? values.from.format('DD/MM/YY') : null,
					begin: '00:00:00',
					end: '24:00:00',
				};

				if (!newChange.from) {
					CustomNotification({
						type: 'error',
						message: 'Campo requerido',
						description: 'Necesitas llenar todos los campos',
					});
					return;
				}
				if (!isTodayOrFuture(newChange.from)) {
					return;
				}
				break;

			case 'Cerrado por vacaciones':
				newChange = {
					id: null,
					motive: values.motive,
					from: values.from ? values.from.format('DD/MM/YY') : null,
					to: values.to ? values.to.format('DD/MM/YY') : null,
					begin: 'CERRADO',
					end: 'CERRADO',
				};

				if (!newChange.from || !newChange.to) {
					CustomNotification({
						type: 'error',
						message: 'Campos requeridos',
						description: 'Necesitas llenar todos los campos',
					});
					return;
				}

				if (!isTodayOrFuture(newChange.from)) {
					return;
				}
				if (!isTodayOrFuture(newChange.to)) {
					return;
				}
				if (!isValidDateRange(newChange.from, newChange.to)) {
					return;
				}
				break;

			default:
				newChange = {
					id: null,
					motive: values.motive,
					from: values.from ? values.from.format('DD/MM/YY') : null,
					to: values.from ? values.from.format('DD/MM/YY') : null,
					begin: 'CERRADO',
					end: 'CERRADO',
				};

				if (!newChange.from) {
					CustomNotification({
						type: 'error',
						message: 'Campo requerido',
						description: 'Necesitas llenar todos los campos',
					});
					return;
				}
				if (!isTodayOrFuture(newChange.from)) {
					return;
				}
				break;
		}

		if (!checkDateOverlap(newChange, temporalChanges)) {
			return;
		} else {
			setTemporalChanges((prev) => [newChange, ...prev]);
		}

		form.setFieldsValue({
			motive: null,
			from: null,
			to: null,
			begin: null,
			end: null,
		});

		setSelectedMotive(null); // si estás usando este estado para manejar visibilidad
	};

	const handleDeleteChip = (indexToRemove) => {
		setTemporalChanges((prev) => prev.filter((_, i) => i !== indexToRemove));
	};

	const handleEdit = () => {
		setSnapshot(form.getFieldsValue(true));

		setSnapshotChanges([...temporalChanges]);

		setEditable(!editable);
	};

	const handleCancel = () => {
		form.setFieldsValue(snapshot);
		setTemporalChanges(snapshotChanges);
		setEditable(!editable);
		handleCancelMotive();
	};

	// useEffect(() => {
	// 	console.log('temporalChanges', temporalChanges);
	// }, [temporalChanges]);

	useEffect(() => {
		if (data) {
			form.setFieldsValue(data);
		}
	}, [data, form]);

	return (
		<div className="own-pharmacy-local-form">
			<h2>{titleForm({ nameLocal: data?.name_local })}</h2>
			<Form
				form={form}
				size="middle"
				onFinish={(values) => handleOnFinish(values)}
				onFinishFailed={handleOnFinishFailed}
				autoComplete="off"
				initialValues={data}
			>
				<section className="own-register-data ">
					<h3>Identificador</h3>
					<Row gutter={[16]} className="own-row">
						<Col span={6}>
							<h4>ID Marca</h4>
							<CustomFormItem name="brand">
								<CustomInput placeholder="Nombre marca" size="middle" disabled={!editable} />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<h4>ID Farmacia</h4>
							<CustomFormItem>
								<CustomInput size="middle" disabled={true} value={data?.code_local} />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<h4>ID Sucursal</h4>
							<CustomFormItem>
								<CustomInput size="middle" disabled={true} value={data?.pharmacy + ' - ' + data?.code_local} />
							</CustomFormItem>
						</Col>
					</Row>
				</section>

				<section className="own-register-data ">
					<h3>Datos</h3>
					<Row gutter={[16]} className="own-row">
						<Col span={6}>
							<h4>Nombre sucursal</h4>
							<CustomFormItem name="name_local" rules={'required'}>
								<CustomInput placeholder="Nombre de sucursal - editable" size="middle" disabled={!editable} />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<h4>Director técnico</h4>
							<CustomFormItem name="name_dt" rules={'required'}>
								<CustomInput placeholder="Nombre y apellido" size="middle" disabled={!editable} />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<h4>Teléfono</h4>
							<CustomFormItem name="phone" rules={'phone'} validateFirst>
								<CustomInput placeholder={FORM.PHONE_EXAMPLE} size="middle" disabled={!editable} />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<h4>E-mail</h4>
							<CustomFormItem name="email" rules={'email'}>
								<CustomInput placeholder="Email" size="middle" disabled={!editable} />
							</CustomFormItem>
						</Col>
					</Row>
				</section>

				<section>
					<h3>Dirección</h3>
					<Row gutter={[16]} className="own-address">
						<Col span={12} className="own-map">
							{coordinates && (
								<>
									<GoogleMap coordinates={coordinates} />
								</>
							)}
						</Col>
						<Col span={12}>
							<Row gutter={[16]}>
								<Col span={12}>
									<h4>{t('address.region')}</h4>
									<CustomFormItem rules={'required'} name={'region'}>
										<CustomSelect
											showSearch
											placeholder="Elegir estado"
											options={props.regionOptions}
											bordered={false}
											disabled={!editable}
											onChange={(e) => {
												props.getCommunes(e);
												handleResetCommune();
											}}
										/>
									</CustomFormItem>
								</Col>
								<Col span={12}>
									<h4>{t('address.commune')}</h4>
									<CustomFormItem rules={'required'} name={'commune'}>
										<CustomSelect
											showSearch
											placeholder={'Elegir'}
											options={communesOptiones}
											bordered={false}
											disabled={!editable}
										/>
									</CustomFormItem>
								</Col>
							</Row>
							<h4>Calle y número</h4>
							<Row gutter={[16]} className="own-input-google-maps">
								<Col span={17}>
									<CustomFormItem name={'direction'}>
										<CustomInput value={capitalizeWords(latlng)} disabled={!editable} onKeyDown={handleKeyDown} />
									</CustomFormItem>
								</Col>

								<Col span={7} className="own-btn-search">
									<CustomButton
										disabled={!editable}
										onClick={() => {
											handleGetAddress();
										}}
									>
										BUSCAR
									</CustomButton>
								</Col>
							</Row>

							<CustomFormItem name={'google_maps'} hidden>
								<CustomInput placeholder={capitalizeWords(latlng)} disabled={true} />
							</CustomFormItem>

							<Row gutter={[16]}>
								<Col span={12}>
									<h4>Latitud</h4>
									<CustomFormItem name={['_geoloc', 'lat']} rules={'geoloc_lat'}>
										<CustomInput value={coordinates?.lat} size="middle" disabled={true} />
									</CustomFormItem>
								</Col>
								<Col span={12}>
									<h4>Longitud</h4>
									<CustomFormItem name={['_geoloc', 'lng']} rules={'geoloc_lng'}>
										<CustomInput value={coordinates?.lng} size="middle" disabled={true} />
									</CustomFormItem>
								</Col>
							</Row>
						</Col>
					</Row>
				</section>

				<section className="own-schedule">
					<h3>Horario habitual</h3>
					<Row gutter={[16]} wrap={false} className="own-row">
						<Col span={3}>
							<Row>
								<Col>
									<p></p>
								</Col>
							</Row>
							<Row className="own-text">
								<Col>
									<p>Desde</p>
								</Col>
							</Row>
							<Row className="own-text">
								<Col>
									<p>Hasta</p>
								</Col>
							</Row>
						</Col>

						{PHARMACY_LOCAL.SCHEDULE_DAYS.map((day, index) => (
							<Col span={3} key={`scheduleDay${index}`} style={{ width: '200px' }}>
								<CustomFormItem name={['schedule', index, 'day']} hidden>
									<CustomInput />
								</CustomFormItem>
								<CustomFormItem name={['schedule', index, 'status']} hidden>
									<CustomInput />
								</CustomFormItem>

								<Row gutter={[16]}>
									<Col className="own-text">{day}</Col>
								</Row>
								<Row gutter={[16]}>
									<Col style={{ width: '100%' }}>
										<CustomFormItem
											name={['schedule', index, 'open']}
											rules={form.getFieldValue(['schedule', index, 'status']) ? 'required' : null}
										>
											<CustomSelect
												disabled={!editable}
												options={PHARMACY_LOCAL.TIME}
												bordered={false}
												{...handleSelect(index)}
											/>
										</CustomFormItem>
									</Col>
								</Row>
								<Row gutter={[16]}>
									<Col style={{ width: '100%' }}>
										<CustomFormItem
											name={['schedule', index, 'close']}
											rules={form.getFieldValue(['schedule', index, 'status']) ? 'required' : null}
										>
											<CustomSelect
												disabled={!editable}
												options={PHARMACY_LOCAL.TIME}
												bordered={false}
												onChange={(e) => console.log(e, form.getFieldValue(['schedule', index, 'day']))}
												{...handleSelect(index)}
											/>
										</CustomFormItem>
									</Col>
								</Row>
							</Col>
						))}
					</Row>
				</section>

				<section>
					<h3>Cambio temporal de Horarios</h3>

					<Row gutter={[16]} className="own-temporal-schedule">
						<Col span={12}>
							<h3> Nuevo cambio </h3>
							<Row className="own-row">
								<h4>Motivo</h4>
							</Row>
							<Row>
								<Col span={24}>
									<CustomFormItem name={'motive'}>
										<CustomSelect
											disabled={!editable}
											options={PHARMACY_LOCAL.MOTIVE.map((item) => ({ label: item, value: item }))}
											bordered={false}
											placeholder="ej. de turno..."
											onChange={handleChangeMotive}
											allowClear
										/>
									</CustomFormItem>
								</Col>
							</Row>

							<Row gutter={[25]}>
								<Col span={12}>
									<h4>Desde</h4>

									<CustomFormItem name={'from'}>
										<CustomDatePicker
											disabled={!editable || disableDesde}
											bordered={true}
											placeholder="00/00/0000"
											format="DD/MM/YYYY"
											suffixIcon={<CalendarOutlined style={{ fontSize: '18px' }} />}
											style={{ width: '100%' }}
											onChange={handleFromDateChange}
											disabledDate={disablePastAndToday}
										/>
									</CustomFormItem>
								</Col>

								<Col span={12}>
									<h4>Hasta</h4>
									<CustomFormItem name={'to'}>
										<CustomDatePicker
											disabled={!editable || disableHasta}
											bordered={true}
											placeholder="00/00/0000"
											format="DD/MM/YYYY"
											suffixIcon={<CalendarOutlined style={{ fontSize: '18px' }} />}
											style={{ width: '100%' }}
											disabledDate={disablePastAndToday}
										/>
									</CustomFormItem>
								</Col>
							</Row>

							<Row gutter={[25]}>
								<Col span={12}>
									<h4>Inicio</h4>

									<CustomFormItem name={'begin'}>
										<CustomSelect
											disabled={!editable || disableInicioFin || lockBeginToday}
											options={PHARMACY_LOCAL.TIME.filter((item) => item.value !== 'CERRADO')}
											bordered={false}
											placeholder="00:00"
											suffixIcon={<ClockCircleOutlined style={{ fontSize: '18px' }} />}
										/>
									</CustomFormItem>
								</Col>

								<Col span={12}>
									<h4>Fin</h4>
									<CustomFormItem name={'end'}>
										<CustomSelect
											disabled={!editable || disableInicioFin}
											options={getValidEndOptions()}
											bordered={false}
											placeholder="00:00"
											suffixIcon={<ClockCircleOutlined style={{ fontSize: '18px' }} />}
										/>
									</CustomFormItem>
								</Col>
							</Row>

							<Row className="own-edit" justify={'end'}>
								<Col>
									<CustomButton disabled={!editable} onClick={handleSaveTemporalChange}>
										GUARDAR
									</CustomButton>
								</Col>
							</Row>
						</Col>

						<Col span={12}>
							<h3>Tus cambios</h3>
							<div className="chip-scroll-wrapper">
								<div className="chip-column-container">
									{temporalChanges.length > 0 ? (
										temporalChanges.map((change, index) => {
											const motive = change.motive?.toLowerCase() ?? '';
											const chipClass = motive.includes('turno')
												? 'chip-green'
												: motive.includes('cerrado')
												? 'chip-red'
												: 'chip-gray';

											return (
												<div key={index} className={`chip-item ${chipClass}`}>
													{change.motive === PHARMACY_LOCAL.MOTIVE[0] ? (
														<span className="chip-text">
															{change.from}, {change.begin} a {change.end} hs, {change.motive}
														</span>
													) : change.motive === PHARMACY_LOCAL.MOTIVE[1] ? (
														<span className="chip-text">
															{change.from}, {change.motive}
														</span>
													) : change.from === change.to ? (
														<span className="chip-text">
															{change.from}, {change.motive}
														</span>
													) : (
														<span className="chip-text">
															{change.from} - {change.to}, {change.motive}
														</span>
													)}

													{editable && <CloseOutlined className="chip-close" onClick={() => handleDeleteChip(index)} />}
												</div>
											);
										})
									) : (
										<p className="chip-empty">No tienes cambios temporales guardados</p>
									)}
								</div>
							</div>
						</Col>
					</Row>
				</section>

				<section className="own-delivery">
					<h3>Forma de entrega</h3>
					<Row gutter={[16]} className="own-row">
						<Col>
							<CustomFormItem name={'delivery'} valuePropName={'checked'}>
								<CustomCheckbox disabled={!editable}>Despacho a domicilio</CustomCheckbox>
							</CustomFormItem>
						</Col>
						<Col>
							<CustomFormItem name={'pharmacy_withdrawal'} valuePropName={'checked'}>
								<CustomCheckbox disabled={!editable}>Retiro en farmacia</CustomCheckbox>
							</CustomFormItem>
						</Col>
					</Row>
				</section>
			</Form>

			<section className="own-edit">
				{data && (
					<Row gutter={[16]} justify={'end'}>
						{!editable && (
							<Col className="own-btn">
								<CustomButton type="primary" htmlType="button" onClick={handleEdit}>
									EDITAR
								</CustomButton>
							</Col>
						)}
						{editable && (
							<>
								<Col className="own-cancel">
									<CustomButton
										type="primary"
										htmlType="button"
										onClick={handleCancel}
									>
										CANCELAR
									</CustomButton>
								</Col>
								<Col className="own-btn">
									<CustomButton
										disabled={disableSaveButton}
										type="primary"
										htmlType="submit"
										onClick={() => {
											form.submit();
											handleCancelMotive();
										}}
									>
										GUARDAR
									</CustomButton>
								</Col>
							</>
						)}
					</Row>
				)}
			</section>
		</div>
	);
}
